import { VStack } from '@chakra-ui/react';

import classNames from 'classnames/bind';
import { Box } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useChatContext } from 'features/chat/context/chat';
import { useChatMessageSchedulingContext } from 'features/chat/context/chatMessageScheduling';

import { ButtonIcon } from 'shared/components/Button';

import styles from 'features/chat/components/Chat.module.css';

const cx = classNames.bind(styles);

export const UnreadMessagesAnchor = ({ onClick }: { onClick: () => void }) => {
  const { unreadMessagesCount } = useChatContext();
  const { isScheduledListVisible } = useChatMessageSchedulingContext();

  // do not show indicator on scheduled messages list
  if (!unreadMessagesCount || isScheduledListVisible) {
    return null;
  }

  return (
    <VStack position="absolute" right="30px" bottom="15px" gap={1}>
      <Box
        className={cx('chat__anchor-text')}
        data-testid="unread-messages-counter"
      >
        {unreadMessagesCount}
      </Box>
      <ButtonIcon
        variant="outline"
        aria-label="unread messages"
        bg="var(--bgPrimary)"
        shadow="0px 2px 4px rgba(0, 0, 0, 0.1), 0px 4px 15px rgba(0, 0, 0, 0.1)"
        size="md"
        onClick={onClick}
      >
        <Icon
          name={iconNames.chevronDown}
          height="12px"
          width="12px"
          stroke="var(--fgPrimary)"
        />
      </ButtonIcon>
    </VStack>
  );
};
